import { render, staticRenderFns } from "./check-dialog.vue?vue&type=template&id=c4f288f2&scoped=true&"
import script from "./check-dialog.vue?vue&type=script&lang=js&"
export * from "./check-dialog.vue?vue&type=script&lang=js&"
import style0 from "./check-dialog.vue?vue&type=style&index=0&id=c4f288f2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4f288f2",
  null
  
)

export default component.exports